var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "overlay-opacity": "0.8", "max-width": "500" },
      model: {
        value: _vm.blocked,
        callback: function ($$v) {
          _vm.blocked = $$v
        },
        expression: "blocked",
      },
    },
    [
      _c(
        "v-card",
        { attrs: { "max-width": "500" } },
        [
          _c(
            "v-card-title",
            [
              _c("v-icon", { attrs: { left: "" } }, [
                _vm._v(_vm._s(_vm.icon_credit)),
              ]),
              _vm._v(" Доступ закрыт "),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c("div", { staticClass: "mb-3" }, [
                _vm._v(" Ваш баланс "),
                _c("b", [_vm._v(_vm._s(_vm.current_client.balance))]),
                _vm._v("₽ "),
                _c("br"),
                _vm._v(" На выкуп заказов надо "),
                _c("b", [_vm._v(_vm._s(_vm.need_pay))]),
                _vm._v("₽ "),
                _c("br"),
                _c("br"),
                _vm._v(
                  " Если вы уже оплатили, ждите подтверждения и обновляйте страницу сайта "
                ),
              ]),
              _c(
                "v-alert",
                {
                  attrs: {
                    icon: _vm.icon_warn,
                    outlined: "",
                    border: "left",
                    type: "warning",
                  },
                },
                [
                  _vm._v(
                    " Для работы с сайтом на вашем балансе должно быть минимум "
                  ),
                  _c("b", { staticStyle: { "white-space": "nowrap" } }, [
                    _vm._v(_vm._s(_vm.blocked_balance) + "₽"),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn mb-3",
                      attrs: { block: "", color: "success" },
                      on: {
                        click: function ($event) {
                          _vm.onPayment(
                            (
                              _vm.blocked_balance - _vm.current_client.balance
                            ).toFixed(2)
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        " Оплатить " +
                          _vm._s(
                            (
                              _vm.blocked_balance -
                              (_vm.current_client.balance - _vm.need_pay)
                            ).toFixed(2)
                          ) +
                          "₽ "
                      ),
                    ]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn mb-3",
                      attrs: { block: "", color: "primary" },
                      on: { click: _vm.onReloadPage },
                    },
                    [_vm._v(" Обновить страницу ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn mb-3",
                      attrs: { block: "", color: "primary" },
                      on: { click: _vm.showBalanceHistories },
                    },
                    [_vm._v(" Посмотреть историю баланса ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn",
                      attrs: { block: "", color: "primary" },
                      on: { click: _vm.onExit },
                    },
                    [_vm._v(" Выход ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }